import { faDatabase, faMapMarkerAlt, faEnvelope, faMobileAlt, faShareAlt } from '@fortawesome/free-solid-svg-icons'
import { 
    faHtml5,
    faCss3Alt,
    faJs,
    faPhp,
    faNodeJs,
    faLaravel,
    faVuejs,
    faGit,
    faBootstrap,
    faFacebookSquare,
    faLinkedin,
    faGithubSquare,
    faGithub,
    faDocker,
    faReact,
    faUnity,
    faPython
} from '@fortawesome/free-brands-svg-icons'

let icons = {
    database: faDatabase,
    map_marker: faMapMarkerAlt,
    envelope: faEnvelope,
    mobile: faMobileAlt,
    share: faShareAlt,
    html: faHtml5,
    css: faCss3Alt,
    js: faJs,
    php: faPhp,
    node: faNodeJs,
    laravel: faLaravel,
    vue: faVuejs,
    git: faGithub,
    bootstrap: faBootstrap,
    facebook: faFacebookSquare,
    linkedin: faLinkedin,
    github: faGithubSquare ,
    docker: faDocker,
    react: faReact,
    unity: faUnity,
    python: faPython
}

export default icons
